import React from 'react';
import ReactDOM from 'react-dom/client'; // Notez l'utilisation de react-dom/client
import App from './App';
import './index.css';

// Rendu avec la nouvelle API createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);